const AdditionalBackground = () => {
  return (
    <div className='absolute additional-bg w-[100%] h-[100vh]' />
  )
}

export default AdditionalBackground